import { css, type RuleSet } from 'styled-components'

const normalCSS = css`
  padding: 3px 15px;
`
const largeCSS = css`
  padding: 7px 23px;
`

export const buttonSizes: Record<'normal' | 'large', RuleSet<object>> = {
  normal: normalCSS,
  large: largeCSS
}
